import styled from '@emotion/styled';

const SectionTitleWrapper = styled.div`
  margin-bottom: 50px;
  margin-top: 50px;
`;

export default SectionTitleWrapper;
